'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('collection-edit', {
      url: '/collection/edit/:name',
      template: '<collection-edit></collection-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/collection/edit/collection-edit.routes.js